<template>
  <div>
     <!-- 冻结金额 -->
     <el-dialog title="冻结金额" :visible.sync="coolDia" width="35%">
      <div class="cool">
        <p>
          <span>￥</span>
          <el-input v-model="freezeMoney" style="width: 50%"></el-input>
        </p>
        <p>--温馨提示--</p>
        <p>1、冻结金额为0，则不冻结金额;</p>
        <p>2、填写金额多少则冻结多少，冻结金额不支持提现。</p>
        <p>
          <el-button  type="danger"@click="falseMethods">取消</el-button>
          <el-button  type="success" v-debounce="okMethods" :disabled="btn1">确定</el-button>
        </p>
      </div>
    </el-dialog>
     <!-- 停止、启用对话框 -->
     <el-dialog
      :title="titleName"
      :visible.sync="titleDialoag"
      width="30%"
      @close="colseDialoag"
    >
      <div class="titledialoag">
        <p>是否确认{{ titleName }}该清分账户?</p>
        <p>
          注:{{
            titleName
          }}该清分账户后，请尽快修改其他清分账户的清分比例，未修改则会影响正常清分，{{
            titleName
          }}请慎重!
        </p>
        <p>
          <el-button type="danger" @click="colseDialoag">取消</el-button>
          <el-button type="success" @click="stopAccount">确定</el-button>
        </p>
      </div>
    </el-dialog>
    <!-- 编辑、添加 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible">
      <el-form :model="vinAccountForm" :rules="vinAccountFormRules" ref="vinAccountFormRef" label-width="80px">
        <el-row type="flex" class="row-bg" justify="space-around" :gutter="24">
          <el-col :span="12">
            <!-- 内容主体区域 -->
            <el-form-item label="提现商户" prop="totalLedgerId">
              <el-select v-model="vinAccountForm.totalLedgerId" @change="changeStationMethods">
                <el-option v-for="item in allshanghu" :key="item.id" :value="item.id"
                  :label="item.trueName"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="账户性质" prop="accountKind">
              <el-select v-model="vinAccountForm.accountKind" @change="changeStationMethods">
                <el-option v-for="item in kind" :key="item.accountKind" :value="item.accountKind"
                  :label="item.name"></el-option>
              </el-select>
            </el-form-item> -->
            <!-- @change="changeStationMethods" -->
            <el-form-item label="证件类型" prop="certType">
              <el-select v-model="vinAccountForm.certType">
                <el-option v-for="item in centterType" :key="item.certType" :value="item.certType"
                  :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <!-- v-if="vinAccountForm.acctType == 0" -->
            <el-form-item label="联行号" prop="bankBranchNo" v-if="vinAccountForm.acctType == 0" required>
              <el-input v-model="vinAccountForm.bankBranchNo"></el-input>
            </el-form-item>
            <el-form-item label="收款卡号" prop="bankCard">
              <el-input v-model="vinAccountForm.bankCard"></el-input>
            </el-form-item>
            <el-form-item label="登录账户" prop="userName" :required="title == '分佣商户'">
              <el-input v-model="vinAccountForm.userName" :disabled="title !== '分佣商户'"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名" prop="trueName">
              <el-input v-model="vinAccountForm.trueName"></el-input>
            </el-form-item>

            <!-- 是否主账户 -->
          </el-col>
          <el-col :span="12">
            <el-form-item label="主账户" prop="isMainAccount">
              <el-radio-group v-model="vinAccountForm.isMainAccount">
                <el-radio v-for="item in leaavel" :key="item.isMainAccount" :label="item.isMainAccount">{{ item.name
                  }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="账户类型" prop="acctType">
              <el-select v-model="vinAccountForm.acctType">
                <el-option v-for="item in accList" :key="item.acctType" :value="item.acctType"
                  :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开户行号" prop="bankNo" required>
              <el-input v-model="vinAccountForm.bankNo"></el-input>
            </el-form-item>
            <el-form-item label="收款银行" prop="bankName">
              <el-input v-model="vinAccountForm.bankName"></el-input>
            </el-form-item>
            <el-form-item label="支行名称" prop="bankBranchName">
              <el-input v-model="vinAccountForm.bankBranchName"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="vinAccountForm.phone"></el-input>
            </el-form-item>
            <!-- 是否主账户 -->
            <!-- :disabled="title !== '分佣商户'" -->
            <!-- :disabled="title !== '分佣商户'" -->
            <el-form-item label="登录密码" prop="passWord">
              <el-input v-model="vinAccountForm.passWord" :disabled="title !== '分佣商户'"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注说明" prop="des">
          <el-input v-model="vinAccountForm.des"></el-input>
        </el-form-item>
        <div>
          <!-- && title == '编辑商户' -->
          <div v-for="(items, index) in objValue" :key="items.uniqueId">
            <el-row :gutter="24">
              <el-col :span="7">
                <el-form-item label="所属电站" prop="stationId">
                  <el-select v-model="items.stationId" @change="currentMethods" filterable>
                    <el-option v-for="(item, index) in stationList" :key="index" :value="item.id"
                      :label="item.stationName" filterable></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="收费类型" prop="type">
                  <el-select v-model="items.type">
                    <el-option v-for="item in typelist" :key="item.id" :value="item.id" :label="item.name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="费率" prop="serviceRate">
                  <el-input-number v-model="items.serviceRate" controls-position="right" :min="0"
                    :max="100"></el-input-number>
                  <span style="margin-left: 8px">%</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-button style="margin-left: 20px" @click="delObj(index)" type="danger">删除</el-button>
              </el-col>
            </el-row>
          </div>
          <el-button style="margin-left: 40%" @click="addObj" v-if="objValue.length < 6">添加电站</el-button>
        </div>
      </el-form>
      <!-- 底部按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogClosed">取 消</el-button>
        <el-button type="primary" v-debounce="editVinAccount">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 清分明细 -->
    <el-dialog :visible.sync="dialoagBtn" title="清分明细" width="80%" @close="MoneyDialoag2" append-to-body
      :close-on-click-modal="false">
      <el-table :data="List" border>
        <el-table-column align="center" label="清分人姓名" prop="merchantMame">
          <template slot-scope="scope">
            <span>
              {{ scope.row.merchantMame }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="清分类型" prop="type" width="100">
          <template slot-scope="scope">
            <span>
              {{
      scope.row.type == 0
        ? '提现成功'
        : scope.row.type == 1
          ? '入账'
          : scope.row.type == 2
            ? '补差'
            : '提现失败'
    }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="清分比例" prop="sortingRatio" width="80">
          <template slot-scope="scope">
            <span>
              {{ scope.row.sortingRatio + '%' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="清分金额" prop="realityMoney" width="100">
          <template slot-scope="scope">
            <span> ￥{{ jisuan(scope.row.realityMoney, 100, 2) }} </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="入账商户" prop="trueName">
          <template slot-scope="scope">
            <span>
              {{ scope.row.trueName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="入账场站" prop="adminName">
          <template slot-scope="scope">
            <span>{{
      scope.row.adminName == '' ||
        scope.row.adminName == undefined ||
        scope.row.adminName == null
        ? '--'
        : scope.row.adminName
    }}</span>
          </template>
        </el-table-column>
        <el-table-column label="流水单号" prop="billCode" width="200">
          <template slot-scope="scope">
            <span>
              {{ scope.row.billCode }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="订单总金额" prop="orderMoney" width="100">
          <template slot-scope="scope">
            <span> ￥{{ jisuan(scope.row.orderMoney, 100, 2) }} </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="电费/服务费" prop="merchantName">
          <template slot-scope="scope">
            <span> ￥{{ jisuan(scope.row.newMoney, 100, 2) }} </span>
            <span> | </span>
            <span> ￥{{ jisuan(scope.row.servicemoney, 100, 2) }} </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="备注" prop="des" width="100">
          <template slot-scope="scope">
            <span>
              {{ scope.row.des }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="入账时间" prop="createTime" width="100">
          <template slot-scope="scope">
            <span>
              {{ scope.row.createTime !== null ? scope.row.createTime : '---' }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3"
        :current-page="indexobj.page" :page-sizes="[8, 20, 50, 100]" :page-size="indexobj.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total3" background>
      </el-pagination>
    </el-dialog>
    <el-row :gutter="20" style="padding-bottom: 10px">
      <el-col :span="3" label="" style="display: flex; flex-direction: row; align-items: center">
        <span style="font-size: 14px; width: 110px; padding-right: 10px">清分人</span>
        <el-select v-model="suoshudianzhan" placeholder="请选择清分人" @change="change_value" filterable>
          <el-option v-for="item in powerStationList" :key="item.id" :label="item.merchantName" :value="item.id">
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="2">
        <el-button type="primary" icon="el-icon-search" @click="chaxun">查询</el-button>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-refresh-left" @click="chongzhi">重置</el-button>
      </el-col>
      <!-- <el-col :span="2">
          <el-button type="primary" icon="el-icon-refresh-left" @click="daochu">导出</el-button>
        </el-col> -->
    </el-row>


    <el-card>
      <li style="
          display: flex;
          justify-content: flex-end;
          margin: -10px 0 10px -1%;
        ">
        <el-button v-if="ownAcount" type="success" icon="el-icon-plus" @click="showVinAccount(0)">分佣商户</el-button>
        <!-- <el-button v-if="daochuType" type="primary" @click="daochuMethods">导出</el-button> -->
      </li>
      <el-table :data="vinAccountList" border>
        <el-table-column align="center" label="清分人姓名" prop="trueName" width="100">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.trueName) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="是否主账户" prop="isMainAccount" width="100">
          <template slot-scope="scope">
            <span>
              {{ typename1(scope.row.isMainAccount) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="账户类型" prop="acctType" width="100">
          <template slot-scope="scope">
            <span :style="stylecss(scope.row.acctType)">
              {{ typename2(scope.row.acctType) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="收款卡号" prop="bankCard" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.bankCard) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="手机号" prop="phone" width="110">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.phone) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="清分比例" prop="serviceRate" width="80">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.serviceRate) + '%' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="清分金额" prop="freezeMoney" width="80">
          <template slot-scope="scope">
            <span> ￥{{ jisuan(scope.row.freezeMoney, 100, 2) }} </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="清分商户" prop="totalMerchantMame" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.totalMerchantMame) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="登录名称" prop="userName" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.userName) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="更新时间" prop="updateTime" width="100">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.updateTime) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="操作（禁用状态下不可提现）" v-if="caozuoquanxian" width="380" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" :disabled="scope.row.b_j_anniu"
              @click="showVinAccount(scope.row)" v-if="ownAcount">编辑</el-button>
            <el-button size="mini" type="warning" :disabled="scope.row.b_j_anniu"
              @click="detailMethods(scope.row)">清分明细</el-button>
            <el-button size="mini" icon="el-icon-s-help" type="danger" @click="moneyMethods(scope.row)"
              v-if="StopMoney">冻结金额</el-button>
            <el-button size="mini" icon="el-icon-turn-off" v-if="(typings && stopAccountStatus) ||
      (scope.row.isMainAccount !== 0 && stopAccountStatus)
      " :type="scope.row.status == 1 ? 'success' : 'danger'" :disabled="scope.row.b_j_anniu"
              @click="stopMethods(scope.row)">{{ scope.row.status == 1 ? '启用' : '停用' }}</el-button>
          </template>
        </el-table-column>
        <div slot="empty" class="empty">
          <span>暂无数据</span>
        </div>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.page" :page-sizes="[6, 20, 50, 100]" :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import caozuo from '@/utils/pubilc.js'
const acn = [5, 11, 17, 18];
export default {
  name: '',
  components: {

  },
  mixins: [],
  props: {

  },
  data() {
    return {
      btn1:false,
      coolDia:false,
      freezeMoney:0,
      titleName: '停用',
      titleDialoag:false,
      total3: 0,
      dialoagBtn: false,
      List: [],
      indexobj: {
        usingType: 0,
        billInfoType: 2,
        gunState: '0,3,4,5,6,7',
        adminId: window.sessionStorage.getItem('adminId'),
        page: 1,
        limit: 8,
        payId: '',
        userNumber: '',
        billCode: '',
        pileCode: '',
        consumeType: 0,
        type: 2,
        stationIds: window.sessionStorage.getItem('stationIds'),
        roleId: window.sessionStorage.getItem('roleId'),
      },
      stationList: [],
      dialogFormVisible: false,
      accList: [
        {
          acctType: 0,
          name: '对公(金融机构开设的公司账户)',
        },
        {
          acctType: 1,
          name: '对私(金融机构开设的私人账户)',
        },
      ],
      centterType: [
        {
          certType: 17,
          name: '身份证',
        },
        {
          certType: 18,
          name: '护照',
        },
        {
          certType: 19,
          name: '港澳临时通行证',
        },
        {
          certType: 20,
          name: '台湾临时通行证',
        },
        {
          certType: 22,
          name: '港澳居民居住证',
        },
        {
          certType: 23,
          name: '台湾居民身份证',
        },
      ],
      leaavel: [
        {
          isMainAccount: 0,
          name: '否',
        },
        {
          isMainAccount: 1,
          name: '是',
        },
      ],
      typelist: [
        {
          id: 0,
          name: '服务费',
        },
        {
          id: 1,
          name: '全额消费',
        }
      ],
      vinAccountFormRules: {
        trueName: {
          required: true,
          message: '请输入真实姓名',
          trigger: 'blur',
        },
        // bankBranchNo: {
        //   required: true, message: '请输入联行号', trigger: 'blur'
        // },
        bankBranchName: {
          required: true,
          message: '请输入支行名称',
          trigger: 'blur',
        },
        acctType: {
          required: true,
          message: '请选择账户类型',
          trigger: 'change',
        },
        // accountKind: {
        //   required: true, message: '请选择账户性质', trigger: 'change'
        // },
        certType: {
          required: true,
          message: '请选择证件类型',
          trigger: 'change',
        },
        merchantName: {
          required: true,
          message: '请输入商户名称',
          trigger: 'blur',
        },
        phone: {
          required: true,
          message: '请输入联系电话',
          trigger: 'blur',
        },
        totalLedgerId: {
          required: true,
          message: '请选择提现商户',
          trigger: 'change',
        },
        // stationId: {
        //   required: true, message: '请选择所属电站', trigger: 'change'
        // },
        bankCard: {
          required: true,
          message: '请输入收款卡号',
          trigger: 'blur',
        },
        bankName: {
          required: true,
          message: '请输入收款银行',
          trigger: 'blur',
        },
        // userName: {
        //   required: true, message: '请输入登录账户', trigger: 'blur'
        // },
        // passWord: {
        //   required: true, message: '请输入登录密码', trigger: 'blur'
        // }
      },
      vinAccountForm: {
        passWord: '',
        userName: '',
        adminId: '',
        trueName: '',
        id: '',
        bankCard: '',
        bankName: '',
        type: '',
        serviceRate: '',
        des: '',
        isMainAccount: 1,
        freezeMoney: '',
        totalLedgerId: '',
        stationId: '',
        serviceRateStr: null,
        typeStr: null,
        bankBranchName: '',
        bankBranchNo: '',
        acctType: 1,
        certType: 17,
        accountKind: 58,
        bankNo: '',
      }, objValue: [],
      title: '',
      powerStationList: [],
      suoshudianzhan: '',
      caozuoquanxian: false,
      daochuType: false,
      stopAccountStatus: false,
      StopMoney: false,
      ownAcount: false,
      quanxianlist: [100, 184, 185, 186, 198],
      vinAccountList: [],
      queryInfo: {
        stationId: null,
        page: 1,
        limit: 6,
        adminId: window.sessionStorage.getItem('adminId'),
        merchantName: '',
        totalLedgerId:
          window.sessionStorage.getItem('roleId') == 1
            ? 0
            : window.sessionStorage.getItem('stationTotalLedgerListId'),
      },
      currentinfo: {
        adminId: window.sessionStorage.getItem('adminId'),
        page: 1,
        limit: 100,
        id: null,
      },
      total: 0,
      typings: false,
      allshanghu: [],
      tilobj: {
        stationId: null,
        page: 1,
        limit: 200,
        adminId: window.sessionStorage.getItem('adminId'),
        merchantName: '',
        totalLedgerId:
          window.sessionStorage.getItem('roleId') == 1
            ? 0
            : window.sessionStorage.getItem('stationTotalLedgerListId'),
      },
    }
  },
  computed: {
    stylecss() {
      return (obj) => {
        const isSpecialType = obj == 0
        const obj1 = {
          color: isSpecialType ? 'red' : '#000',
        }
        return obj1
      }
    },
    shiji() {
      return function (abc, bac) {
        return ((abc * 1 + bac * 1) / 100).toFixed(2)
      }
    },
    wait_s() {
      return function (e) {
        return ((e.money - e.giveMoney) / 100).toFixed(2)
      }
    },
    time_all() {
      return function (val) {
        const hr = val.billCode.slice(val.pileCode.length, val.billCode.length)
        return hr
      }
    },
    jisuan() {
      return function (obj, num, fixed) {
        return (obj / num).toFixed(fixed)
      }
    },
    shifu() {
      return function (val) {
        return ((val.billMoney - val.billMoneygive) / 100).toFixed(2)
      }
    },
  },
  watch: {

  },
  created() {
    this.typings = window.sessionStorage.getItem('roleId') == 1;
    this.initMethods();
    this.startMethods();
    this.publist()
  },
  mounted() {
    this.defaultMethods();
  },
  methods: {
    falseMethods() {
      this.coolDia = false
    },
    // 冻结金额
    okMethods() {
      this.vinAccountForm.freezeMoney = this.freezeMoney * 100;
      this.btn1 = true;
      this.$http.post('station-ledger/updStationLedger', this.vinAccountForm)
        .then((res) => {
          this.$message({
            msg:res.data.code>0? '冻结金额失败，请检查你的金额格式后，再提交'
                : '冻结金额成功',
            type: res.data.code> 0 ? 'error' : 'success',
          })
          this.coolDia = false
        })
    },
    MoneyDialoag2() {
      this.dialoagBtn = false
    },
    colseDialoag() {
      this.titleDialoag = false
    },
    stopAccount() {
      this.vinAccountForm.status = this.titleName == '启用' ? 0 : 1
      this.$http
        .post('station-ledger/updStationLedger', this.vinAccountForm)
        .then((res) => {
          this.$message({
            type: res.data.code !== 0 ? 'error' : 'success',
            message: `${this.titleName}成功`,
          })
          this.titleDialoag = false
          if (res.data.code !== 0) return
          this.defaultMethods()
        })
    },
    // 清分明细
    handleSizeChange3(newSize) {
      this.indexobj.limit = newSize
      this.indexobj.page = 1
      this.getIndex2()
    }, //清分明细
    handleCurrentChange3(newPage) {
      this.indexobj.page = newPage
      this.getIndex2()
    },
    getIndex2() {
      this.$http
        .get('station-ledger/getStationLedgerLog', {
          params: {
            stationLedgerId: this.ids,
            page: this.indexobj.page,
            limit: this.indexobj.limit,
          },
        })
        .then((res) => {
          this.dialoagBtn = true
          if (res.data.code !== 0) return
          this.List = res.data.data
          this.total3 = res.data.count
        })
    },
    delObj(index) {
      this.objValue.splice(index, 1)
      this.$forceUpdate()
    },
    currentMethods(el) {
      const els = this.objValue.findIndex((item) => {
        return item.stationId == el
      })
      const stationName = this.stationList.find(
        (item) => item.id == el
      )?.stationName;
      this.$http.get(`station-ledger/orStation/${el}`).then((res1) => {
        const { code } = res1.data
        if (code > 0) {
          this.$message.error(
            `第${els}行${stationName}已有清分人，请仔细核对！`
          )
          this.delObj(els)
          return
        }

      })
    },
    detailMethods(e) {
      this.ids = e.id
      this.$http
        .get('station-ledger/getStationLedgerLog', {
          params: {
            stationLedgerId: e.id,
            page: 1,
            limit: 8,
          },
        })
        .then((res) => {
          this.dialoagBtn = true
          if (res.data.code !== 0) return
          this.List = res.data.data
          this.total3 = res.data.count
        })
    },
    step2() {
      this.$http
        .post('station-ledger/editStationLedger', this.vinAccountForm)
        .then((res) => {
          console.log(this.vinAccountForm, '商户970清分人员参数')
          this.btn1 = res.data.code > 0
          if (this.title !== '分佣商户') {
            this.$message({
              type: this.btn1 ? 'error' : 'success',
              message: this.btn1
                ? `${this.title}失败！`
                : `${this.title}成功！`,
            })
            this.objValue = []
            this.freezeMoney = ''
            this.defaultMethods()
            this.dialogFormVisible = false
            this.coolDia = false
            return
          }
          let objj = {
            username: this.vinAccountForm.userName,
            password: this.vinAccountForm.passWord,
            roleId: 11,
            roleName: '分账商户',
            adminId: window.sessionStorage.getItem('adminId'),
            picId: 0,
            realname: this.vinAccountForm.trueName,
            phone: this.vinAccountForm.phone,
            status: 0,
            isApp: 0,
            des: '分账商户',
            stationIds: this.objValue.map((item) => item.stationId).join(','),
            typeStr: this.objValue.map((item) => item.type).join(','),
            serviceRateStr: this.objValue
              .map((item) => item.serviceRate)
              .join(','),
          }
          console.log(objj,791);
          // 添加清分商户（子）
          this.$http.post('admin/addAdmin', objj).then((ress) => {
            this.$message({
              type: ress.data.code > 0 ? 'error' : 'success',
              message:
                ress.data.code > 0
                  ? `${this.title}失败！`
                  : `${this.title}成功！`,
            })
            this.objValue = []
            this.freezeMoney = ''
            this.defaultMethods()
            this.dialogFormVisible = false
            this.coolDia = false
          })
        })
    },
    async initMethods() {
      const promises = this.quanxianlist.map(id => caozuo([id]));
      try {
        const results = await Promise.all(promises);
        this.caozuoquanxian = results[0];
        this.ownAcount = results[1];
        this.StopMoney = results[2]
        this.stopAccountStatus = results[3]
        this.daochuType = results[4]
      } catch (error) {
        console.error("权限检查出错", error);
      }
    },
    // 费控判断
    typeName(obj) {
      return !obj || obj == '' ? '--' : obj
    },
    // 类型判断
    typename1(obj) {
      return !obj || obj == '' ? '--' : obj == 0 ? '非主账户' : '主账户'
    },
    // 类型判断
    typename2(obj) {
      return !obj || obj == '' ? '--' : obj == 0 ? '对公' : '对私'
    },
    // 添加键值对
    addObj() {
      this.objValue.push({
        uniqueId: Date.now(),
        stationId: null,
        type: null,
        serviceRate: 0,
      })
      this.$forceUpdate()
    },
    editDialogClosed() {
      this.$refs.vinAccountFormRef.resetFields();
      this.objValue = [];
      this.dialogFormVisible = false;
    },
    editVinAccount() {
      const {
        adminId,
        trueName,
        bankCard,
        bankName,
        phone,
        passWord,
        userName,
        stationId,
        totalLedgerId,
        acctType,
        bankBranchNo,
        bankNo,
      } = this.vinAccountForm;
      this.$refs.vinAccountFormRef.validate(async (valid) => {
        if (!valid) return
        this.vinAccountForm.adminId = Number(this.queryInfo.adminId)
        if (!trueName || trueName == '') return this.$message.error('请输入真实姓名')
        if (!bankCard || bankCard == '') return this.$message.error('请输入收款卡号')
        if (!bankName || bankName == '') return this.$message.error('请输入收款银行')
        if (!phone || phone == '') return this.$message.error('请输入联系电话')
        if (this.title == '添加商户') {
          if (passWord == '' || userName == '')
            return this.$message.error('请输入登录账户、登录密码')
          this.vinAccountForm.userName = this.vinAccountForm.userName.replace(
            /\s+/g,
            ''
          )
          this.vinAccountForm.passWord = this.vinAccountForm.passWord.replace(
            /\s+/g,
            ''
          )
        }
        // if (this.vinAccountForm.serviceRate == '') return this.$message.error('请输入费率');
        // if (this.vinAccountForm.type == '') return this.$message.error('请选择收费类型');
        this.vinAccountForm.trueName = this.vinAccountForm.trueName.replace(
          /\s+/g,
          ''
        )
        this.vinAccountForm.bankCard = this.vinAccountForm.bankCard.replace(
          /\s+/g,
          ''
        )
        this.vinAccountForm.bankName = this.vinAccountForm.bankName.replace(
          /\s+/g,
          ''
        )
        this.vinAccountForm.phone = this.vinAccountForm.phone.replace(
          /\s+/g,
          ''
        )

        // if (stationId == '' || this.objValue.length == 0)
        //   return this.$message.error('请选择所属电站')
        if (totalLedgerId == '') return this.$message.error('请选择提现商户')

        if (acctType == 0) {
          if (!bankNo || bankNo == '' || bankNo == '0')
            return this.$message.error('请输入银行行号')
          if (!bankBranchNo || bankBranchNo == '')
            return this.$message.error('请输入联行号')
          this.vinAccountForm.bankBranchNo =
            this.vinAccountForm.bankBranchNo.replace(/\s+/g, '')
          this.vinAccountForm.bankBranchName =
            this.vinAccountForm.bankBranchName.replace(/\s+/g, '')
        }
        if (this.title !== '分佣商户') {
          if (!this.vinAccountForm.accountKind) return console.log('--')
          this.vinAccountForm.stationId = this.objValue
            .map((item) => item.stationId)
            .join(',')
          this.vinAccountForm.typeStr = this.objValue
            .map((item) => item.type)
            .join(',')
          this.vinAccountForm.serviceRateStr = this.objValue
            .map((item) => item.serviceRate)
            .join(',')
          this.step2()
          return
        }
        this.comm()
      })
    },
    comm() {
      const { totalLedgerId, acctType, isMainAccount } = this.vinAccountForm
      // let abc = this.objValue.map(item=>item.stationId).join(',');
      this.vinAccountForm.stationId = this.objValue
        .map((item) => item.stationId)
        .join(',')
      this.vinAccountForm.typeStr = this.objValue
        .map((item) => item.type)
        .join(',')
      this.vinAccountForm.serviceRateStr = this.objValue
        .map((item) => item.serviceRate)
        .join(',')
      this.vinAccountForm.accountKind =
        acctType == 0 ? 57 : acctType == 1 ? 58 : null
      if (!this.vinAccountForm.accountKind) return console.log('--')
      this.step2()
    },
    // 分账信息
    changeStationMethods() {
      this.stationList = [];
      const target = this.allshanghu.find(item => item.id == this.vinAccountForm.totalLedgerId);
      this.defaultApimethods(target?.adminId);
    },
    // 页码修改
    handleSizeChange(newSize) {
      console.log(newSize, 547);
      this.queryInfo.limit = newSize;
      this.queryInfo.page = 1;
      this.defaultMethods()
    },
    //页条修改 
    handleCurrentChange(newPage) {
      console.log(newPage, 554);
      this.queryInfo.page = newPage;
      this.queryInfo.limit = 6;
      this.defaultMethods()
    },
    // 状态修改
    stopMethods(e) {
      this.titleName = e.status !== 0 ? '启用' : '停用';
      this.vinAccountForm = e;
      this.titleDialoag = true;
    },
    // 冻结金额
    moneyMethods(e) {
      this.vinAccountForm = e;
      this.$http
        .get(`station-ledger/getStationLedgerById/${e.id}`)
        .then((res) => {
          this.freezeMoney = (res.data.data.freezeMoney / 100).toFixed(2)
          this.coolDia = true
        })
    },
    // 上传附件
    uploadTil() {

    },
    // 编辑、分佣商户
    async showVinAccount(row) {
      this.title = row == 0 ? '分佣商户' : "编辑商户";
      this.chushihua();
      if (row == 0) {
        this.dialogFormVisible = true;
        return
      }
      console.log(row, 902);
      const { data: res } = await this.$http.get(`station-ledger/getStationLedgerById/${row.id}`);
      if (res.code > 0) return;
      this.vinAccountForm = res.data;
      this.methodsDefault(row.stationId);
      const target = this.allshanghu.find(item => item.id == this.vinAccountForm.totalLedgerId);
      this.defaultApimethods(target?.adminId);
      console.log(target, 698);
      this.radio = this.vinAccountForm.isMainAccount == 1 ? '是' : '否';
      const { typeStr, stationId, type, serviceRate, serviceRateStr } = res.data;
      this.dialogFormVisible = true;
      const parse = (val, str) => val ?? str?.split(',');
      const types = parse(type, typeStr);
      const rates = parse(serviceRate, serviceRateStr);
      let stationIdd = '';
      if (!stationId || stationId == '') {
        stationIdd = ''
      } else {
        stationIdd = stationId.includes(',') ? stationId.split(',').map(item => item) : stationId
      }
      if (stationId.includes(',')) {
        this.objValue = Array.from(
          { length: stationIdd.length },
          (_, i) => ({
            serviceRate,
            type,
            stationId: stationIdd[i],
            uniqueId: Date.now()[i],
          })
        )
        return;
      }
      this.objValue = [
        {
          serviceRate: rates,
          type: types,
          stationId,
          uniqueId: Date.now(),
        }
      ]
    },
    defaultApimethods(e) {
      this.$http
        .get('station-total-ledger/getAllStationByStationTotalLedgerId', {
          params: {
            adminId: e,
            page: 1,
            limit: 300,
          },
        })
        .then((resb) => {
          resb.data.data.map(item => {
            this.stationList.push({
              id: String(item.id),
              stationName: item.stationName
            })
          })
          console.log(this.stationList, 753);
        })
    },
    // 获取密码
    async methodsDefault(e) {
      await this.$http
        .get(`station-ledger/getUserInfoByStationId/${e}`)
        .then((ress) => {
          this.vinAccountForm.userName = ress.data.code !== 0 ? '' : ress.data.data.username;
          this.vinAccountForm.passWord =
            ress.data.code !== 0 ||
              ress.data.data.password == null ||
              ress.data.data.password == ''
              ? ''
              : '******';
        })
    },
    chushihua() {
      this.vinAccountForm = {
        passWord: '',
        userName: '',
        adminId: '',
        trueName: '',
        id: '',
        bankCard: '',
        bankName: '',
        type: '',
        serviceRate: '',
        des: '',
        isMainAccount: 1,
        freezeMoney: '',
        totalLedgerId: '',
        stationId: '',
        serviceRateStr: null,
        typeStr: null,
        bankBranchName: '',
        bankBranchNo: '',
        acctType: 1,
        certType: 17,
        accountKind: 58,
        bankNo: '',
      };
      this.objValue = [];
    },
    //  导出
    daochuMethods() {
      // this.$http.get('station-ledger/export',{params:})
    },
    // 查询
    chaxun() {
      this.queryInfo.page = 1
      this.defaultMethods()
    },
    // 重置
    chongzhi() {
      this.queryInfo = {
        // vin: '',
        companyName: '',
        carNumber: '',
        // startTime: null,
        // endTime: null,
        stationId: null,
        page: 1,
        limit: 6,
        adminId: window.sessionStorage.getItem('adminId'),
        stationIds: window.sessionStorage.getItem('stationIds'),
        roleId: window.sessionStorage.getItem('roleId'),
        totalLedgerId:
          window.sessionStorage.getItem('roleId') == 1
            ? 0
            : window.sessionStorage.getItem('stationTotalLedgerListId'),
      }
      this.suoshudianzhan = ''
      this.defaultMethods()
    },
    // 修改清分人
    change_value(e) {
      this.powerStationList.map((item) => {
        if (item.id !== e) return
        this.queryInfo.merchantName = item.merchantName
        console.log(window.sessionStorage.getItem('adminId'), '717')
        this.defaultMethods()
      })
    },
    startMethods() {
      console.log(this.currentinfo, 265);
      this.$http.get('station-total-ledger/getAllStationTotalLedger', {
        params: this.currentinfo,
      })
        .then((res) => {
          if (res.data.code !== 0) return
          this.allshanghu = res.data.data
        })
    },
    async publist() {
      const roleId = Number(window.sessionStorage.getItem('roleId'));
      if (!acn.includes(roleId)) {
        const { data: res } = await this.$http.get(
          'station-ledger/getAllStationLedger',
          { params: this.tilobj }
        )
        this.powerStationList = res.code !== 0 ? [] : res.data;
        console.log(this.powerStationList, 744)
        return;
      }
      let obj = {
        adminId: this.queryInfo.adminId,
        roleId,
        page: 1,
        limit: 10,
      }
      if (acn.includes(roleId) && roleId !== 5) {
        obj.IsMainAccount = 0
      }
      const { data: res } = await this.$http.get(
        'financial-overview/getAllStationLedger',
        {
          params: obj,
        }
      )
      this.powerStationList = res.code !== 0 ? [] : res.data
      console.log(this.powerStationList, 763)
    },
    // 初始化
    async defaultMethods() {
      const roleId = Number(window.sessionStorage.getItem('roleId'));
      // let objj = this.tilobj;
      // objj.limit = 6;
      if (!acn.includes(roleId)) {
        const { data: res } = await this.$http.get(
          'station-ledger/getAllStationLedger',
          { params: this.queryInfo }
        )
        if (res.code !== 0) return
        this.vinAccountList = res.data;
        this.total = res.count;
        console.log(res.data, this.vinAccountList, 331)
        return;
      }
      let obj = {
        adminId: this.queryInfo.adminId,
        roleId,
        page: this.queryInfo.page,
        limit: this.queryInfo.limit,
      }
      if (acn.includes(roleId) && roleId !== 5) {
        obj.IsMainAccount = 0
      }
      const { data: res } = await this.$http.get(
        'financial-overview/getAllStationLedger',
        {
          params: obj,
        }
      )
      if (res.code !== 0) return
      this.vinAccountList = res.data;
      console.log(res.data, this.vinAccountList, 351)
      this.total = res.count
    }

  }
};
</script>
<style lang='less' scoped></style>